<div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="space-between stretch" class="dtc-wrapper">
  <div fxFlex fxFill class="dtc-main">
    <ng-content select="[main]"></ng-content>
  </div>

  <div fxFlex.gt-sm="350px" class="dtc-right">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
